define([
  'axios',
  'js-cookie',
], (axios, jscookie) => {
  function _getRequestConfig() {
    return {
      withCredentials: false,
      headers: {
        'X-Sumo-Auth': jscookie.get('__smToken'),
      },
    };
  }

  function fetchFeatures(siteId, sumoUrl) {
    if (!siteId) return Promise.reject('No siteId.');
    if (!sumoUrl) return Promise.reject('No sumoUrl');
    return axios.get(`${sumoUrl}/api/site/${siteId}/features`, _getRequestConfig())
      .then(({ data }) => {
        if (data && data.featuresMap) return data.featuresMap;
        throw new Error('Couldn\'t fetch features.');
      })
      .catch(error => Promise.reject(error));
  }

  return {
    fetchFeatures,
  };
});
